import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconBrandDialpadMeetings",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, o = ["aria-label", "data-qa", "aria-hidden"];
function v(e, c, i, h, _, a) {
  return r(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--brand-dialpad-meetings"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Brand Dialpad Meetings",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...c[0] || (c[0] = [
    s("path", {
      d: "M15.194 7.338c-.772 0-1.519.284-2.102.8a3.285 3.285 0 0 0-1.072 2.012V5.658a.05.05 0 0 0-.03-.045.047.047 0 0 0-.053.011l-1.875 1.97a3.149 3.149 0 0 0-1.248-.256c-1.769 0-3.205 1.46-3.205 3.26 0 1.8 1.435 3.26 3.206 3.26.772 0 1.519-.284 2.102-.8a3.285 3.285 0 0 0 1.072-2.012v4.491c0 .044.052.066.083.034l1.875-1.97c.395.17.819.257 1.247.256 1.77 0 3.206-1.459 3.206-3.26 0-1.8-1.435-3.259-3.206-3.259ZM4.322 19.82a.2.2 0 1 0 .402 0v-.762c0-.241.14-.468.409-.468.315 0 .369.212.369.46v.77a.2.2 0 1 0 .402 0v-.787c0-.241.148-.443.405-.443.315 0 .37.212.37.46v.77a.2.2 0 1 0 .402 0v-.823c-.001-.504-.21-.791-.681-.791a.713.713 0 0 0-.587.338c-.094-.216-.282-.338-.565-.338-.22 0-.43.133-.524.298v-.062a.2.2 0 1 0-.402 0v1.379Zm4.136.238c.19 0 .38-.048.551-.136.076-.04.098-.134.058-.209-.047-.086-.16-.112-.251-.075a.952.952 0 0 1-.351.067c-.268 0-.5-.147-.558-.431h1.358s.01-.08.01-.155c0-.5-.383-.913-.86-.913a.92.92 0 0 0-.924.927c0 .587.456.925.967.925Zm-.554-1.08c.054-.255.257-.424.489-.424a.49.49 0 0 1 .492.425h-.981Zm2.621 1.08c.19 0 .38-.048.552-.136.076-.04.098-.134.058-.209-.047-.086-.16-.112-.251-.075a.953.953 0 0 1-.351.067c-.268 0-.5-.147-.558-.431h1.358s.01-.08.01-.155c0-.5-.383-.913-.86-.913a.92.92 0 0 0-.924.927c0 .587.456.925.966.925Zm-.553-1.08c.054-.255.257-.424.488-.424a.49.49 0 0 1 .493.425h-.981Zm2.372 1.08a.75.75 0 0 0 .32-.072c.067-.031.09-.11.064-.178-.037-.093-.155-.126-.252-.105a.389.389 0 0 1-.082.01c-.101 0-.191-.062-.191-.252v-.892h.375a.164.164 0 1 0 0-.327h-.376v-.386a.2.2 0 0 0-.402 0v.386h-.1a.164.164 0 0 0 0 .327h.1v.88c0 .41.178.609.544.609Zm.886-.036h.402v-1.58a.2.2 0 1 0-.402 0v1.58Zm.199-1.947a.245.245 0 0 0 .246-.24.248.248 0 0 0-.246-.245.245.245 0 0 0-.243.244c0 .133.109.241.243.241Zm.699 1.745a.2.2 0 1 0 .402 0v-.73c0-.295.191-.5.456-.5.3 0 .365.17.365.46v.77a.2.2 0 1 0 .402 0V19c0-.474-.16-.794-.644-.794a.668.668 0 0 0-.58.29v-.054a.2.2 0 1 0-.402 0v1.379Zm2.822.73c.514 0 .934-.313.934-.935v-1.373H17.5v.266c-.094-.177-.336-.302-.608-.302-.496 0-.822.384-.822.863 0 .478.326.86.822.86.326 0 .518-.163.59-.306v.014c0 .363-.188.608-.572.608a.912.912 0 0 1-.392-.09c-.08-.04-.187-.024-.234.053-.038.06-.027.14.034.179.162.103.38.163.632.163Zm.029-.97a.493.493 0 0 1-.5-.511c0-.295.218-.515.5-.515.282 0 .503.216.503.5 0 .31-.213.525-.503.525Zm1.935.478c.333 0 .764-.151.764-.569 0-.366-.347-.5-.68-.571-.16-.033-.308-.061-.308-.184 0-.093.134-.155.268-.155a.92.92 0 0 1 .312.052c.099.035.214 0 .258-.095a.167.167 0 0 0-.075-.223 1.11 1.11 0 0 0-.499-.107c-.315 0-.673.186-.673.535 0 .35.29.45.63.543.177.05.358.083.358.213 0 .125-.192.187-.355.187a.84.84 0 0 1-.374-.087c-.106-.052-.242-.022-.291.084-.033.07-.018.155.047.197.13.087.341.18.618.18Z",
      fill: "#7C52FF"
    }, null, -1)
  ])], 10, o);
}
const f = /* @__PURE__ */ l(m, [["render", v]]);
export {
  f as default
};
//# sourceMappingURL=brand-dialpad-meetings.js.map
